import { Badge } from "@/components/ui/badge";
import { Check, X } from "lucide-react";
import { useTranslation } from "react-i18next";

export const InsuranceBadge = ({ insurance }: { insurance: boolean }) => {
  const { t } = useTranslation("shared");
  if (insurance) {
    return (
      <Badge className="gap-2 rounded-xl border-transparent bg-green-500 px-3 py-1 text-sm font-medium text-white">
        <Check className="h-6 w-6 text-white" />
        {t("insuranceBadge.enabled")}
      </Badge>
    );
  }
  return (
    <Badge className="gap-2 rounded-xl border-transparent bg-red-500 px-3 py-1 text-sm font-medium text-white">
      <X className="h-6 w-6 text-white" />
      {t("insuranceBadge.disabled")}
    </Badge>
  );
};
